import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-valid-icon',
    templateUrl: './valid-icon.component.html',
    styleUrls: ['./valid-icon.component.scss']
})
export class ValidIconComponent extends AbstractIcon {
    constructor() {
        super();
        this.height = 24;
        this.width = 24;
    }
}
